import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <h1>Hello CodeSandbox</h1>
      <h2>Start editing to see some magic happen!</h2>
      <img src="https://wallpaperaccess.com/full/1749181.jpg" alt="asd" />
    </div>
  );
}
